module.exports = "static/assets/af8e46c9477a8cadeb6c26b4686407a5.svg";